import { getDepartmentId } from 'src/app/services/store-snapshot.service';
import { LoadQuantityTypes } from 'src/app/quantity-type/state/quantity-type.actions';
import { LoadDepartments } from 'src/app/department/state/department.actions';
import { LoadTenants } from 'src/app/tenant/state/tenant.action';
import { LoadDepartmentGroups } from 'src/app/department/state/department-group.actions';
import { LoadShifts } from 'src/app/crew-management/state/shifts/shift.actions';
import { LoadActivities } from 'src/app/crew-management/state/activities/activity.actions';
import { LoadJobPositions } from 'src/app/competence/state/job-position.actions';
import { LoadJobPositionGroups } from 'src/app/competence/state/job-position-group.actions';
import { LoadCompetenceGroups } from 'src/app/competence/state/competence-group.actions';
import { LoadCompetences } from 'src/app/competence/state/competence.actions';
import { Injectable } from '@angular/core';
import { StateToken, State, Action, StateContext, Selector, createSelector } from '@ngxs/store';
import { append, patch, updateItem } from '@ngxs/store/operators';
import { LoadDocuments } from 'src/app/document-user/state/document.actions';
import {
  MainTableFilterModel,
  MainTableFilterSearchByModel,
  MainTableSortingType,
} from 'src/app/shared/models/main-table-filter.model';
import { LoadUserCompetences } from 'src/app/shared/user-view/state/competence-user.actions';
import { LoadAllUsersAllTenants, LoadUsers } from 'src/app/shared/user-view/state/user.actions';
import {
  LoadPlannedActivities,
  LoadPlannedActivitiesForTenant,
  LoadPlannedActivitiesUsers,
} from 'src/app/crew-management-user/state/planned-activities/planned-activities.actions';
import { LoadRunTimesForDepartment } from 'src/app/run-time/state/run-time.actions';
import { LoadSeverities } from 'src/app/non-conformance-admin/state/severities/severity.actions';
import {
  LoadCurrentPersonnel,
  LoadMissingConfirmations,
} from 'src/app/crew-management-user/state/current-personnel/current-personnel.actions';
import {
  LoadCurrentAndPlannedPaxOverviews,
  LoadCurrentPaxOverviews,
  LoadPastPaxOverviews,
  LoadPlannedPaxOverviews,
} from 'src/app/crew-management-user/state/pax-overview/pax-overview.actions';
import { LoadAlerts } from 'src/app/alert/state/alert.actions';
import { LoadCompetenceRequirements } from 'src/app/competence/state/competence-requirement.actions';
import { LoadPagedMedicines } from 'src/app/medicine-user/state/medicine.actions';
import { LoadProductCategories } from 'src/app/storage-admin/state/product-category.actions';
import { LoadProducts } from 'src/app/storage-user/state/product.actions';
import { LoadPaxes } from 'src/app/user/state/pax.actions';
import { LoadNonConformanceTypes } from 'src/app/non-conformance-admin/state/types/non-conformance-type.actions';
import { LoadSuppliers } from 'src/app/order-admin/state/supplier/supplier.actions';
import { LoadDrills } from 'src/app/drills-user/state/drills.actions';
import { LoadPurchasers } from 'src/app/order-admin/state/purchaser/purchaser.actions';
import { cloneDeep } from 'lodash-es';
import {
  LoadApprovedOrders,
  LoadOrdersSentToSuppliers,
  LoadPagedOrders,
} from 'src/app/order-user/state/order.actions';
import { LoadOrderTypes } from 'src/app/order-admin/state/order-types/order-type.actions';
import { LoadSeaStates } from 'src/app/non-conformance-admin/state/sea-state/non-conformance-sea-state.actions';
import { LoadLocationOnDepartments } from 'src/app/non-conformance-admin/state/location-on-department/non-conformance-location-on-department.actions';
import { LoadWeatherInformation } from 'src/app/non-conformance-admin/state/weather-information/non-conformance-weather-information.actions';
import { LoadRiskAssessments } from 'src/app/risk-assessment-user/state/risk-assessment.actions';
import { LoadRiskAssessmentValues } from 'src/app/risk-assessment-admin/state/risk-assessment-value.actions';
import { RiskAssessmentValueType } from 'src/app/risk-assessment-admin/enums/risk-assessment-value-type.enum';
import { LoadCauses } from 'src/app/non-conformance-admin/state/cause/non-conformance-cause.actions';
import { LoadCertificateTypes } from 'src/app/certificate-admin/state/certificate-types.action';
import { LoadPrivilegeTemplates } from 'src/app/competence/state/privilege-template.actions';
import {
  LoadTrips,
  LoadTripsChangeLog,
} from 'src/app/crew-management-user/state/trips/trip.actions';
import {
  LoadDueListDueCompetences,
  LoadDueListWarnings,
  LoadMyDueListWarnings,
} from 'src/app/due-list/state/due-list.actions';
import {
  LoadComponentSpareParts,
  LoadJobSpareParts,
} from 'src/app/maintenance-user/state/spare-part.actions';
import { LoadProductTypes } from 'src/app/storage-admin/state/product-type.actions';
import {
  LoadComponentProductTypes,
  LoadJobProductTypes,
} from 'src/app/maintenance-user/state/product-type-user.actions';
import { GetComponentHistoryById } from 'src/app/maintenance-user/state/component-history.actions';
import { LoadStandardJobTemplates } from 'src/app/maintenance-admin/state/standard-job-template.actions';
import {
  LoadEntraIdDepartmentMappings,
  LoadEntraIdJobPositionMappings,
  LoadEntraIdShiftMappings,
} from 'src/app/tenant/state/entra-id-mapping.actions';
import { LoadCompetenceRoles } from 'src/app/competence/state/competence-roles.actions';
import { LoadWorkScheduleTemplates } from 'src/app/work-and-rest-admin/state/work-schedule-template/work-schedule-template.actions';
import { LoadOvertimeTypes } from 'src/app/work-and-rest-admin/state/overtime-type/overtime-type.actions';
import { LoadWorkPlanTemplates } from 'src/app/work-and-rest-admin/state/work-plan-template/work-plan-template.actions';
import { LoadWorkOverviewList } from 'src/app/work-and-rest-user/state/work-overview.actions';
import { LoadAdditionalTimeRequests } from 'src/app/work-and-rest-user/state/additional-time.actions';
import { LoadMyUserCompetences } from '../../shared/user-view/state/competence-user.actions';
import { LoadTasks } from '../../task-user/state/task.actions';
import { LoadDeliveryConditions } from '../../order-admin/state/delivery-condition.actions';
import { LoadAccountGroups } from '../../order-admin/state/account-group.actions';
import { LoadAccounts } from '../../order-admin/state/account.actions';
import { LoadDocumentsByMenu } from '../../document-user/state/document.actions';
import { LoadMedicineCategories } from '../../medicine-admin/state/medicine-category.actions';
import { LoadProductOwners } from '../../product-owner/state/product-owner.actions';
import { LoadJobTypes } from '../../maintenance-admin/state/job-type.actions';
import { LoadMaintenanceJobs } from '../../maintenance-user/state/maintenance-job.actions';
import { LoadNonConformances } from '../../non-conformance-user/state/non-conformance.actions';
import {
  LoadCertificateGroups,
  LoadCertificateLog,
  LoadCertificatesByMenu,
} from '../../certificate-user/state/certificate.actions';
import { MainTableFilterModulesEnum } from '../enums/main-table-filter-modules.enum';

import {
  ApplySearch,
  ApplyPaging,
  ApplyAdditional,
  ApplySorting,
  ClearFilterDetails,
  ReFetchWithLastFilters,
  ApplyColumnFilters,
  ReFetchAndClearSorting,
  ResetFilterPageIndex,
  ResetCurrentFilter,
  ResetFilterSearch,
} from './main-table-filter.actions';
import { MainTableFilterIdentification } from '../models/main-table-filter-identification.model';
import { defaultPageIndex } from '../table-config/table-paging-defaults';

export interface MainTableFilterStateModel {
  filtersByModule: MainTableFilterModel[];
  currentFilter: MainTableFilterModel | undefined;
  previousModule: MainTableFilterModulesEnum | undefined;
  previousDepartment: string | undefined;
  modulePageSizes: { [key: string]: number };
  moduleSearchBy: { [key: string]: MainTableFilterSearchByModel[] };
  moduleSorting: { [key: string]: { orderBy: string; ascDesc: MainTableSortingType } };
  moduleSearchTerm: { [key: string]: string };
}

const MAIN_TABLE_FILTER_STATE_TOKEN = new StateToken<MainTableFilterStateModel>('mainTableFilter');

@State<MainTableFilterStateModel>({
  name: MAIN_TABLE_FILTER_STATE_TOKEN,
  defaults: {
    filtersByModule: [],
    currentFilter: undefined,
    previousModule: undefined,
    previousDepartment: undefined,
    modulePageSizes: {},
    moduleSearchBy: {},
    moduleSorting: {},
    moduleSearchTerm: {},
  },
})
@Injectable()
export class MainTableFilterState {
  private readonly actionMap: { [key: string]: (f: MainTableFilterModel) => any } = {
    [MainTableFilterModulesEnum.Certificates]: (f) => new LoadCertificatesByMenu(f),
    [MainTableFilterModulesEnum.CertificateStructures]: (f) => new LoadCertificateGroups(f),
    [MainTableFilterModulesEnum.Competences]: (f) => new LoadCompetences(f.additional, f),
    [MainTableFilterModulesEnum.CompetenceGroups]: (f) => new LoadCompetenceGroups(f.additional, f),
    [MainTableFilterModulesEnum.CompetenceUsers]: (f) => new LoadUserCompetences(f.additional, f),
    [MainTableFilterModulesEnum.MyCompetenceUsers]: (f) =>
      new LoadMyUserCompetences(f.additional, f),
    [MainTableFilterModulesEnum.CompetenceRequirement]: (f) => new LoadCompetenceRequirements(f),
    [MainTableFilterModulesEnum.PositionGroups]: (f) => new LoadJobPositionGroups(f),
    [MainTableFilterModulesEnum.CompetenceRoles]: (f) => new LoadCompetenceRoles(f),
    [MainTableFilterModulesEnum.JobPositions]: (f) => new LoadJobPositions(f),
    [MainTableFilterModulesEnum.Activities]: (f) => new LoadActivities(f),
    [MainTableFilterModulesEnum.Shifts]: (f) => new LoadShifts(f),
    [MainTableFilterModulesEnum.Trips]: (f) => new LoadTrips(f),
    [MainTableFilterModulesEnum.Documents]: (f) => new LoadDocuments(f, f.additional),
    [MainTableFilterModulesEnum.DocumentsByMenu]: (f) => new LoadDocumentsByMenu(f),
    [MainTableFilterModulesEnum.DepartmentGroups]: (f) => new LoadDepartmentGroups(f),
    [MainTableFilterModulesEnum.JobTypes]: (f) => new LoadJobTypes(f),
    [MainTableFilterModulesEnum.StandardJobTemplates]: (f) => new LoadStandardJobTemplates(f),
    [MainTableFilterModulesEnum.MaintenanceJobs]: (f) => new LoadMaintenanceJobs(f),
    [MainTableFilterModulesEnum.Drills]: (f) => new LoadDrills(f),
    [MainTableFilterModulesEnum.Tasks]: (f) => new LoadTasks(f),
    [MainTableFilterModulesEnum.NonConformances]: (f) => new LoadNonConformances(f.additional, f),
    [MainTableFilterModulesEnum.NonConformanceTypes]: (f) => new LoadNonConformanceTypes(f),
    [MainTableFilterModulesEnum.NonConformanceCauses]: (f) => new LoadCauses(f),
    [MainTableFilterModulesEnum.NonConformanceSeaStates]: (f) => new LoadSeaStates(f),
    [MainTableFilterModulesEnum.NonConformanceWeatherInformation]: (f) =>
      new LoadWeatherInformation(f),
    [MainTableFilterModulesEnum.NonConformanceLocationOnDepartment]: (f) =>
      new LoadLocationOnDepartments(f),
    [MainTableFilterModulesEnum.Users]: (f) => new LoadUsers(f),
    [MainTableFilterModulesEnum.ProductOwnerUsers]: (f) => new LoadAllUsersAllTenants(f),
    [MainTableFilterModulesEnum.PlannedActivities]: (f) => new LoadPlannedActivities(f),
    [MainTableFilterModulesEnum.PlannedActivitiesForTenant]: (f) =>
      new LoadPlannedActivitiesForTenant(f),
    [MainTableFilterModulesEnum.ProductOwner]: (f) => new LoadProductOwners(f),
    [MainTableFilterModulesEnum.Tenant]: (f) => new LoadTenants(f),
    [MainTableFilterModulesEnum.Departments]: (f) => new LoadDepartments(f),
    [MainTableFilterModulesEnum.RunTime]: (f) => new LoadRunTimesForDepartment(f),
    [MainTableFilterModulesEnum.MedicineCategories]: (f) => new LoadMedicineCategories(f),
    [MainTableFilterModulesEnum.Medicines]: (f) => new LoadPagedMedicines(f, f.additional),
    [MainTableFilterModulesEnum.ProductCategories]: (f) => new LoadProductCategories(f),
    [MainTableFilterModulesEnum.Products]: (f) => new LoadProducts(f, f.additional),
    [MainTableFilterModulesEnum.Severities]: (f) => new LoadSeverities(f),
    [MainTableFilterModulesEnum.CurrentPersonnel]: (f) => new LoadCurrentPersonnel(f),
    [MainTableFilterModulesEnum.MissingConfirmation]: (f) => new LoadMissingConfirmations(f),
    [MainTableFilterModulesEnum.CurrentPaxOverview]: (f) => new LoadCurrentPaxOverviews(f),
    [MainTableFilterModulesEnum.PlannedPaxOverview]: (f) => new LoadPlannedPaxOverviews(f),
    [MainTableFilterModulesEnum.PastPaxOverview]: (f) => new LoadPastPaxOverviews(f),
    [MainTableFilterModulesEnum.CurrentAndPlannedPaxOverview]: (f) =>
      new LoadCurrentAndPlannedPaxOverviews(f),
    [MainTableFilterModulesEnum.AdminPaxes]: (f) => new LoadPaxes(f),
    [MainTableFilterModulesEnum.Alerts]: (f) => new LoadAlerts(f),
    [MainTableFilterModulesEnum.Accounts]: (f) => new LoadAccounts(f),
    [MainTableFilterModulesEnum.AccountGroups]: (f) => new LoadAccountGroups(f),
    [MainTableFilterModulesEnum.DeliveryConditions]: (f) => new LoadDeliveryConditions(f),
    [MainTableFilterModulesEnum.QuantityTypes]: (f) => new LoadQuantityTypes(f),
    [MainTableFilterModulesEnum.Suppliers]: (f) => new LoadSuppliers(f),
    [MainTableFilterModulesEnum.Purchasers]: (f) => new LoadPurchasers(f),
    [MainTableFilterModulesEnum.PlannedActivityUsers]: (f) => new LoadPlannedActivitiesUsers(f),
    [MainTableFilterModulesEnum.Orders]: (f) => new LoadPagedOrders(f.additional, f),
    [MainTableFilterModulesEnum.OrderTypes]: (f) => new LoadOrderTypes(f),
    [MainTableFilterModulesEnum.ApprovedOrders]: (f) => new LoadApprovedOrders(f),
    [MainTableFilterModulesEnum.OrdersSentToSupplier]: (f) => new LoadOrdersSentToSuppliers(f),
    [MainTableFilterModulesEnum.RiskAssessments]: (f) => new LoadRiskAssessments(f, f.additional),
    [MainTableFilterModulesEnum.Hazards]: (f) =>
      new LoadRiskAssessmentValues(RiskAssessmentValueType.Hazard, f),
    [MainTableFilterModulesEnum.Consequences]: (f) =>
      new LoadRiskAssessmentValues(RiskAssessmentValueType.Consequence, f),
    [MainTableFilterModulesEnum.Locations]: (f) =>
      new LoadRiskAssessmentValues(RiskAssessmentValueType.Location, f),
    [MainTableFilterModulesEnum.OperationTypes]: (f) =>
      new LoadRiskAssessmentValues(RiskAssessmentValueType.OperationType, f),
    [MainTableFilterModulesEnum.MitigatingMeasures]: (f) =>
      new LoadRiskAssessmentValues(RiskAssessmentValueType.MitigatingMeasure, f),
    [MainTableFilterModulesEnum.CertificateTypes]: (f) => new LoadCertificateTypes(f),
    [MainTableFilterModulesEnum.CertificateLog]: (f) => new LoadCertificateLog(f.additional, f),
    [MainTableFilterModulesEnum.PrivilegeTemplates]: (f) => new LoadPrivilegeTemplates(f),
    [MainTableFilterModulesEnum.DueListWarnings]: (f) => new LoadDueListWarnings(f),
    [MainTableFilterModulesEnum.DueListCompetences]: (f) => new LoadDueListDueCompetences(f),
    [MainTableFilterModulesEnum.DueListMyWarnings]: (f) => new LoadMyDueListWarnings(f),
    [MainTableFilterModulesEnum.ComponentSpareParts]: (f) =>
      new LoadComponentSpareParts(f.additional, f),
    [MainTableFilterModulesEnum.ComponentHistory]: (f) =>
      new GetComponentHistoryById(f.additional, f),
    [MainTableFilterModulesEnum.JobSpareParts]: (f) => new LoadJobSpareParts(f.additional, f),
    [MainTableFilterModulesEnum.ComponentProductTypes]: (f) =>
      new LoadComponentProductTypes(f.additional, f),
    [MainTableFilterModulesEnum.JobProductTypes]: (f) => new LoadJobProductTypes(f.additional, f),
    [MainTableFilterModulesEnum.ProductTypes]: (f) => new LoadProductTypes(f),
    [MainTableFilterModulesEnum.TripsChangeLog]: (f) => new LoadTripsChangeLog(f),
    [MainTableFilterModulesEnum.EntraIdDepartmentMappings]: (f) =>
      new LoadEntraIdDepartmentMappings(f),
    [MainTableFilterModulesEnum.EntraIdJobPositionMappings]: (f) =>
      new LoadEntraIdJobPositionMappings(f),
    [MainTableFilterModulesEnum.EntraIdShiftMappings]: (f) => new LoadEntraIdShiftMappings(f),
    [MainTableFilterModulesEnum.WorkScheduleTemplates]: (f) => new LoadWorkScheduleTemplates(f),
    [MainTableFilterModulesEnum.OvertimeTypes]: (f) => new LoadOvertimeTypes(f),
    [MainTableFilterModulesEnum.WorkPlans]: (f) => new LoadWorkPlanTemplates(f),
    [MainTableFilterModulesEnum.WorkRest]: (f) => new LoadWorkOverviewList(f.additional, f),
    [MainTableFilterModulesEnum.TimeApprovals]: (f) => new LoadAdditionalTimeRequests(f),
  };

  @Action(ApplySearch, { cancelUncompleted: true })
  applySearch(
    ctx: StateContext<MainTableFilterStateModel>,
    { module, searchTerm, additional }: ApplySearch
  ) {
    const existingFilter = this.findFilter(ctx.getState().filtersByModule, module, additional);
    const newFilter = existingFilter || new MainTableFilterModel(module);
    newFilter.departmentId = existingFilter?.departmentId || getDepartmentId();
    newFilter.searchTerm = searchTerm;
    newFilter.pageIndex = 0;
    if (additional !== undefined) newFilter.additional = additional;
    if (existingFilter) {
      this.updateExistingFilter(ctx, newFilter, module, additional);
    } else {
      this.addNewFilter(ctx, newFilter);
    }
    this.setModuleSearchTerm(ctx, module, searchTerm);
    this.dispatchFilterToProperModule(newFilter, module, ctx);
  }

  @Action(ApplyAdditional, { cancelUncompleted: true })
  applyAdditional(
    ctx: StateContext<MainTableFilterStateModel>,
    { module, additional }: ApplyAdditional
  ) {
    const { filtersByModule } = ctx.getState();
    const existingFilter = this.findFilter(filtersByModule, module, additional);
    const newFilter = existingFilter || new MainTableFilterModel(module);
    newFilter.departmentId = existingFilter?.departmentId || getDepartmentId();
    newFilter.additional = additional;
    if (existingFilter) {
      newFilter.pageIndex = 0;
      this.updateExistingFilter(ctx, newFilter, module, additional);
    } else {
      this.addNewFilter(ctx, newFilter);
    }
    this.dispatchFilterToProperModule(newFilter, module, ctx);
  }

  @Action(ApplyPaging, { cancelUncompleted: true })
  applyPaging(
    ctx: StateContext<MainTableFilterStateModel>,
    { module, pageIndex, pageSize, additional }: ApplyPaging
  ) {
    const existingFilter = this.findFilter(ctx.getState().filtersByModule, module, additional);
    const existingModuleSearchBy = ctx.getState().moduleSearchBy[module];
    const existingModuleSearchTerm = ctx.getState().moduleSearchTerm[module];
    const existingModuleSorting = ctx.getState().moduleSorting[module];
    const newFilter = cloneDeep(existingFilter) || new MainTableFilterModel(module);
    newFilter.departmentId = existingFilter?.departmentId || getDepartmentId();
    newFilter.pageSize = pageSize;
    newFilter.searchBy = existingModuleSearchBy;
    newFilter.searchTerm = existingModuleSearchTerm;
    newFilter.orderBy = existingModuleSorting?.orderBy;
    newFilter.ascDesc = existingModuleSorting?.ascDesc;
    if (additional !== undefined) newFilter.additional = additional;
    if (existingFilter) {
      // if pageSize changes, then always go to pageIndex 0
      newFilter.pageIndex = pageSize !== existingFilter.pageSize ? 0 : pageIndex;
      this.updateExistingFilter(ctx, newFilter, module, additional);
    } else {
      this.addNewFilter(ctx, newFilter);
    }
    this.setModulePageSize(ctx, module, newFilter.pageSize);
    this.dispatchFilterToProperModule(newFilter, module, ctx);
  }

  @Action(ApplySorting, { cancelUncompleted: true })
  applySorting(
    ctx: StateContext<MainTableFilterStateModel>,
    { module, orderBy, ascDesc, additional }: ApplySorting
  ) {
    const existingFilter = this.findFilter(ctx.getState().filtersByModule, module, additional);
    const newFilter = existingFilter || new MainTableFilterModel(module);
    newFilter.departmentId = existingFilter?.departmentId || getDepartmentId();
    newFilter.orderBy = orderBy;
    newFilter.ascDesc = ascDesc;
    if (existingFilter) {
      this.updateExistingFilter(ctx, existingFilter, module, additional);
    } else {
      newFilter.additional = additional;
      this.addNewFilter(ctx, newFilter);
    }
    this.setModuleSorting(ctx, module, orderBy, ascDesc);
    this.dispatchFilterToProperModule(newFilter, module, ctx);
  }

  @Action(ApplyColumnFilters, { cancelUncompleted: true })
  applyColumnFilters(
    ctx: StateContext<MainTableFilterStateModel>,
    { module, filters, additional }: ApplyColumnFilters
  ) {
    const existingFilter = this.findFilter(ctx.getState().filtersByModule, module, additional);
    const newFilter = existingFilter || new MainTableFilterModel(module);
    newFilter.searchBy = filters;
    newFilter.pageIndex = 0;
    if (existingFilter) {
      this.updateExistingFilter(ctx, existingFilter, module, additional);
    } else {
      newFilter.additional = additional;
      this.addNewFilter(ctx, newFilter);
    }
    this.setModuleSearchBy(ctx, module, filters);
    this.dispatchFilterToProperModule(newFilter, module, ctx);
  }

  @Action(ReFetchWithLastFilters, { cancelUncompleted: true })
  reFetch(
    ctx: StateContext<MainTableFilterStateModel>,
    { module, additional }: ReFetchWithLastFilters
  ) {
    const existingFilter = this.findFilter(ctx.getState().filtersByModule, module, additional);
    if (existingFilter) {
      this.dispatchFilterToProperModule(existingFilter, module, ctx);
    } else {
      console.warn('ReFetch: No filter found for module: ', module);
    }
  }

  @Action(ReFetchAndClearSorting, { cancelUncompleted: true })
  reFetchAndClearSorting(
    ctx: StateContext<MainTableFilterStateModel>,
    { module, additional }: ReFetchAndClearSorting
  ) {
    const existingFilter = this.findFilter(ctx.getState().filtersByModule, module, additional);

    if (existingFilter) {
      existingFilter.orderBy = '';
      existingFilter.ascDesc = '';
      this.setModuleSorting(ctx, module, '', '');
      this.dispatchFilterToProperModule(existingFilter, module, ctx);
    } else {
      console.warn('ReFetch: No filter found for module: ', module);
    }
  }

  @Action(ClearFilterDetails, { cancelUncompleted: true })
  clearFilterDetails(ctx: StateContext<MainTableFilterStateModel>) {
    const allFilters = ctx.getState().filtersByModule;
    const clearedFilters = allFilters.map((filter: MainTableFilterModel) => {
      const clearedFilter = new MainTableFilterModel(filter.module);
      clearedFilter.pageSize = filter.pageSize;
      clearedFilter.additional = filter.additional;
      return clearedFilter;
    });
    ctx.setState(
      patch({
        filtersByModule: clearedFilters,
        moduleSearchBy: {},
        moduleSorting: {},
      })
    );
  }

  @Action(ResetFilterPageIndex, { cancelUncompleted: true })
  resetCurrentFilterPage(
    ctx: StateContext<MainTableFilterStateModel>,
    { filterIdentification }: ResetFilterPageIndex
  ) {
    const { moduleName, additional } = filterIdentification;
    const filter = this.findFilter(
      ctx.getState().filtersByModule,
      moduleName as MainTableFilterModulesEnum,
      additional
    );
    if (filter) {
      filter.pageIndex = 0;
      this.updateExistingFilter(ctx, filter, moduleName as MainTableFilterModulesEnum, additional);
    }
  }

  @Action(ResetFilterSearch, { cancelUncompleted: true })
  resetCurrentFilterSearch(
    ctx: StateContext<MainTableFilterStateModel>,
    { module, additional }: ResetFilterSearch
  ) {
    const filter = this.findFilter(
      ctx.getState().filtersByModule,
      module as MainTableFilterModulesEnum,
      additional
    );
    if (filter) {
      filter.searchBy = undefined;
      this.updateExistingFilter(ctx, filter, module as MainTableFilterModulesEnum, additional);
    }
  }

  @Action(ResetCurrentFilter, { cancelUncompleted: true })
  resetCurrentFilter(ctx: StateContext<MainTableFilterStateModel>) {
    ctx.setState(patch({ currentFilter: undefined }));
  }

  @Selector()
  static getCurrentPageIndex(state: MainTableFilterStateModel) {
    return state.currentFilter?.pageIndex || defaultPageIndex;
  }

  @Selector()
  static getAllPagingDetails(state: MainTableFilterStateModel) {
    return state.filtersByModule;
  }

  @Selector()
  static getCurrentFilterDetails(
    state: MainTableFilterStateModel
  ): MainTableFilterModel | undefined {
    return state.currentFilter;
  }

  static getModulePageSize(module: any): (state: MainTableFilterStateModel) => number | undefined {
    return createSelector([MainTableFilterState], (state: MainTableFilterStateModel) => {
      return state.modulePageSizes[module];
    });
  }

  static getPagingDetails(
    filterIdentification: MainTableFilterIdentification
  ): (state: MainTableFilterStateModel) => MainTableFilterModel | undefined {
    return createSelector([MainTableFilterState], (state: MainTableFilterStateModel) => {
      return state.filtersByModule.find(
        MainTableFilterState.findFilterFn(
          filterIdentification.moduleName as MainTableFilterModulesEnum,
          filterIdentification.additional
        )
      );
    });
  }

  private findFilter(
    filters: MainTableFilterModel[],
    module: MainTableFilterModulesEnum,
    additional: any
  ) {
    return cloneDeep(
      filters.find(MainTableFilterState.findFilterFn(module, additional)) as MainTableFilterModel
    );
  }

  private static findFilterFn(module: MainTableFilterModulesEnum, additional: any) {
    const filterFunctions: any = {
      [MainTableFilterModulesEnum.DocumentsByMenu]: (filter: MainTableFilterModel) =>
        // filter.additional.menuId === additional.menuId &&
        filter.additional.tabName === additional.tabName,
      [MainTableFilterModulesEnum.Users]: (filter: MainTableFilterModel) =>
        filter.additional.includeDeleted === additional.includeDeleted &&
        filter.additional.includePaused === additional.includePaused &&
        filter.additional.includeDeactivated === additional.includeDeactivated,
      [MainTableFilterModulesEnum.Tasks]: (filter: MainTableFilterModel) =>
        filter.additional.menuId === additional.menuId &&
        filter.additional.showDeleted === additional.showDeleted,
      [MainTableFilterModulesEnum.Drills]: (filter: MainTableFilterModel) =>
        filter.additional.menuId === additional.menuId &&
        filter.additional.showDeleted === additional.showDeleted,
      [MainTableFilterModulesEnum.Certificates]: (filter: MainTableFilterModel) =>
        filter.additional.menuId === additional.menuId &&
        filter.additional.showDeleted === additional.showDeleted,
      [MainTableFilterModulesEnum.MaintenanceJobs]: (filter: MainTableFilterModel) =>
        filter.additional.componentId === additional.componentId &&
        filter.additional.showDeleted === additional.showDeleted,
      [MainTableFilterModulesEnum.Trips]: (filter: MainTableFilterModel) =>
        filter.additional?.status === additional?.status,
      default: (filter: MainTableFilterModel) => filter.additional === additional,
    };
    return (filter: MainTableFilterModel) => {
      if (filter.module !== module) {
        return false;
      }
      const additionalFilterFunction = filterFunctions[module] || filterFunctions.default;
      return additionalFilterFunction(filter);
    };
  }

  private updateExistingFilter(
    ctx: StateContext<MainTableFilterStateModel>,
    filter: MainTableFilterModel,
    module: MainTableFilterModulesEnum,
    additional: any
  ): void {
    ctx.setState(
      patch({
        filtersByModule: updateItem<MainTableFilterModel>(
          MainTableFilterState.findFilterFn(module, additional),
          filter
        ),
        currentFilter: filter,
      })
    );
  }

  private addNewFilter(
    ctx: StateContext<MainTableFilterStateModel>,
    filter: MainTableFilterModel
  ): void {
    ctx.setState(
      patch({
        filtersByModule: append([filter]),
        currentFilter: filter,
      })
    );
  }

  private setModuleSorting(
    ctx: StateContext<MainTableFilterStateModel>,
    module: string,
    orderBy: string,
    ascDesc: MainTableSortingType
  ) {
    ctx.setState(
      patch({
        moduleSorting: {
          [module]: {
            orderBy,
            ascDesc,
          },
        },
      })
    );
  }

  private setModuleSearchBy(
    ctx: StateContext<MainTableFilterStateModel>,
    module: string,
    filters: MainTableFilterSearchByModel[]
  ) {
    ctx.setState(
      patch({
        moduleSearchBy: {
          [module]: filters,
        },
      })
    );
  }

  private setModulePageSize(
    ctx: StateContext<MainTableFilterStateModel>,
    module: string,
    pageSize: number
  ) {
    ctx.setState(
      patch({
        modulePageSizes: {
          [module]: pageSize,
        },
      })
    );
  }

  private setModuleSearchTerm(
    ctx: StateContext<MainTableFilterStateModel>,
    module: string,
    searchTerm: string
  ) {
    ctx.setState(
      patch({
        moduleSearchTerm: {
          [module]: searchTerm,
        },
      })
    );
  }

  private dispatchFilterToProperModule(
    filter: MainTableFilterModel,
    module: MainTableFilterModulesEnum,
    ctx: StateContext<MainTableFilterStateModel>
  ): void {
    try {
      const action = this.actionMap[module];
      if (!action) {
        console.warn(`No action handler found for module: ${module}`);
        return;
      }
      ctx.dispatch(action(filter));
    } catch (error) {
      console.error(`Error dispatching filter for module ${module}:`, error);
    }
  }
}
